<template>
  <div id="paginaDestinatari">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Destinatari</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown
              variant="link"
              no-caret
              right
              class="chart-dropdown"
              toggle-class="p-0"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item href="#"> ... </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist
                  id="dropDestinatari"
                  ref="dropDestinatari"
                  :query="queryDestinatari"
                  :dataSource="destinatariList"
                  :index="destinatariIndex"
                  :fields="destinatariFields"
                  :change="onDestinatarioChange"
                  v-model="destinatarioCorrente"
                  placeholder="Seleziona un Destinatario"
                ></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
            </b-row>
            <b-row> </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Sezione Ministero -->
      <b-col xl="12" md="12" v-show="showDestMinistero">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Ministero</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Parametro Ministero</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="tmpCosto"
                  floatLabelType="Never"
                  cssClass=""
                  format="###"
                  placeholder="Parametro"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Preventivazione</ejs-button
                >
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Rendicontazione</ejs-button
                >
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Sezione Regione -->
      <b-col xl="12" md="12" v-show="showDestRegione">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Regione Piemonte</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Parametro Regione Piemonte</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="tmpCosto"
                  floatLabelType="Never"
                  cssClass=""
                  format="###"
                  placeholder="Parametro"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Preventivazione</ejs-button
                >
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Rendicontazione</ejs-button
                >
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Sezione Comune -->
      <b-col xl="12" md="12" v-show="showDestComune">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Comune di Novara</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Parametro Comune di Novara</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="tmpCosto"
                  floatLabelType="Never"
                  cssClass=""
                  format="###"
                  placeholder="Parametro"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Preventivazione</ejs-button
                >
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Rendicontazione</ejs-button
                >
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Sezione Teatro Coccia -->
      <b-col xl="12" md="12" v-show="showDestTeatroCoccia">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Ministero</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Parametro Teatro Coccia</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="tmpCosto"
                  floatLabelType="Never"
                  cssClass=""
                  format="###"
                  placeholder="Parametro"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Preventivazione</ejs-button
                >
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Rendicontazione</ejs-button
                >
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <!-- Sezione Compagnia San Paolo -->
      <b-col xl="12" md="12" v-show="showDestCompagniaSanPaolo">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Compagnia San Paolo</b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="mb-2">
                <label for="costoA" class="h5">Parametro Compagnia San Paolo</label>
                <ejs-numerictextbox
                  id="costoA"
                  v-model="tmpCosto"
                  floatLabelType="Never"
                  cssClass=""
                  format="###"
                  placeholder="Parametro"
                  showSpinButton="false"
                  showClearButton="true"
                  :readonly="true"
                />
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Preventivazione</ejs-button
                >
              </b-col>
              <b-col xl="4" md="4" class="mb-2">
                <ejs-button v-on:click.native="btnCreate"
                  >Genera Rendicontazione</ejs-button
                >
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>


      
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  LinkPlugin,
  AlertPlugin,
  ProgressPlugin,
  ToastPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Vuexy
// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
} from "@syncfusion/ej2-vue-inputs";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons'

const axios = require("axios");
// use bootstrap-vue
Vue.use(LayoutPlugin);
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(DropdownPlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(SpinnerPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
enableRipple(true);
// api
const apiCostoProduzioniRicercaUrl = "/demo/api/costoproduzioni/ricerca";

export default Vue.extend({
  components: {},
  data() {
    return {
      showDestMinistero: false,
      showDestRegione: false,
      showDestComune: false,
      showDestTeatroCoccia: false,
      showDestCompagniaSanPaolo: false,
      showDestRegione: false,

      tmpCosto: null,
      loading: false,
      // lista valori Destinatari
      destinatariList: [
        { label: "Teatro Coccia", val: "teatroCoccia" },
        { label: "Comune di Novara", val: "comuneNovara" },
        { label: "Regione Piemonte", val: "regionePiemonte" },
        { label: "Ministero", val: "ministero" },
        { label: "Compagnia San Paolo", val: "compagniaSanPaolo" },
      ],
      destinatariFields: { text: "label", value: "val" },
      destinatariIndex: -1,
      queryDestinatari: null,
      destinatarioCorrente: null,
      // gestione elementi nascosti
      nonMostrare: false,

      // generali
      settings: {
        formatoData: "dd-MM-yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
      },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

    };
  },
  created() {
    // log
    console.log("Pagina Destinatari Creata"); 
  },
  mounted() {
    // disabilito gridA
    //this.$refs.gridA.$el.classList.add('disablegrid')
    //document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropDestinatari
    this.$refs.dropDestinatari.ej2Instances.focusIn();
  },

  provide: {
    // per grid
    //grid: [GridToolbar, GridSort, GridFilter, GridEdit],
  },
  methods: {
    // per dropdownlist combinate
    onDestinatarioChange: function (e) {
      // avvio il loader
      this.loading = true;
      // spengo tutte le sezioni
      this.showDestMinistero = false;
      this.showDestRegione = false;
      this.showDestCompagniaSanPaolo = false;
      this.showDestComune = false;
      this.showDestTeatroCoccia = false;
      // mostro la sezione selezionata
      if (this.destinatarioCorrente == "ministero") {
        this.showDestMinistero = true;
      } else if (this.destinatarioCorrente == "regionePiemonte") {
        this.showDestRegione = true;
      } else if (this.destinatarioCorrente == "comuneNovara") {
        this.showDestComune = true;
      } else if (this.destinatarioCorrente == "compagniaSanPaolo") {
        this.showDestCompagniaSanPaolo = true;
      } else if (this.destinatarioCorrente == "teatroCoccia") {
        this.showDestTeatroCoccia = true;
      }
      this.loading = false;
    },
    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
  },
  computed: {
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import "~@syncfusion/ej2-schedule/styles/material.css";
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
